import { inject, Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { ImportSkillsFlowData, ImportSkillsStepDefinition } from '@core/tellent-skills-types';

import { ImportSkillsFlowStepService } from './import-skills-flow-step.service';

@Injectable({ providedIn: 'root' })
export class ImportSkillsFlowStateService {
  private readonly flowSteps = inject(ImportSkillsFlowStepService).flowSteps;
  private readonly flowDataSubject = new BehaviorSubject<Partial<ImportSkillsFlowData>>({});

  public readonly flowData$ = this.flowDataSubject.asObservable();

  private currentStepIndex = 0;

  public initializeFlow(): ImportSkillsStepDefinition | null {
    this.currentStepIndex = 0;
    this.flowDataSubject.next({});
    return this.findNextValidStep();
  }

  public advanceFlow(
    stepData: Partial<ImportSkillsFlowData> | null,
  ): ImportSkillsStepDefinition | null {
    if (stepData) {
      this.flowDataSubject.next({ ...this.flowDataSubject.value, ...stepData });
    }
    this.currentStepIndex++;
    return this.findNextValidStep();
  }

  public goBack(): ImportSkillsStepDefinition | null {
    const data = this.flowDataSubject.value;
    const prevStep =
      this.flowSteps
        .slice(0, this.currentStepIndex)
        .findLast(step => !step.skipOnBack && (!step.canMatch || step.canMatch(data))) ?? null;
    if (prevStep) {
      this.currentStepIndex = this.flowSteps.indexOf(prevStep);
    }
    return prevStep;
  }

  private findNextValidStep(): ImportSkillsStepDefinition | null {
    const data = this.flowDataSubject.value;
    while (this.currentStepIndex < this.flowSteps.length) {
      const stepDef = this.flowSteps[this.currentStepIndex];
      if (stepDef.canMatch && !stepDef.canMatch(data)) {
        this.currentStepIndex++;
        continue;
      }
      return stepDef;
    }
    return null;
  }
}
